import { makeObservable, observable, action, computed } from 'mobx'
import type Template from './Template'
import { v4 as uuidv4 } from 'uuid'
import Store from './Store'

export default class TemplateSection {
  id: string
  name: string = ''
  position: number = 0
  template: Template
  store: Store

  deleted: boolean = false
  saving: boolean = false
  lastError?: string

  constructor(store: Store, template: Template, name: string) {
    makeObservable(this, {
      id: false,
      name: observable,
      position: observable,
      items: computed,
      fromProvider: action,
      setName: action,
      setLastError: action,
      setDeleted: action,
      setSaving: action,
      delete: action,
    })
    this.store = store
    this.template = template
    this.id = uuidv4()
    this.name = name
  }

  get items() {
    return this.template.sortedItems.filter(
      (item) => item.sectionId === this.id
    )
  }

  addItem = (name: string) => {
    const item = this.template.buildItem(name)
    item.sectionId = this.id
    item.position = this.items.length
    item.handleCreate()
  }

  setName = (name: string) => {
    this.name = name
    // this.handleUpdate()
  }

  setDeleted(value: boolean) {
    this.deleted = value
  }

  setSaving(value: boolean) {
    this.saving = value
  }

  setLastError(value: string | undefined) {
    this.lastError = value
  }

  fromProvider(json: string | object) {
    const { id, name, position } =
      typeof json === 'object' ? json : JSON.parse(json)
    if (id) this.id = id
    if (name) this.name = name
    if (position) this.position = position
  }

  handleCreate = () => {
    this.store.provider
      .createTemplateSection(this.template.id, { name: this.name })
      .then((item) => this.fromProvider(item))
      .catch((e) => {
        this.setLastError('Failed to add item')
        throw e
      })
      .finally(() => {
        this.setSaving(false)
      })
  }

  delete() {
    this.template.removeSection(this.id)
  }

  handleDelete = () => {
    this.store.provider
      .deleteTemplateSection(this.template.id, this.id)
      .catch((e) => {
        this.setLastError('Failed to add item')
        throw e
      })
      .finally(() => {
        this.setSaving(false)
      })
  }
}
